/*** IMPORTS FROM imports-loader ***/
var global = window;

export * from './configuration';
export * from './remoteConfiguration';
//# sourceMappingURL=index.js.map
